import { Stats } from '../types'

export const getStatsAuthors = (stats: Stats | null) =>
  stats?.authors?.results?.filter((a: any) => a.count >= 2)
